export const toast = {
  success: (message) => {
    window.dispatchEvent(new CustomEvent('show-toast', { detail: { type: 'success', message } }));
  },
  error: (message) => {
    window.dispatchEvent(new CustomEvent('show-toast', { detail: { type: 'error', message } }));
  },
  info: (message) => {
    window.dispatchEvent(new CustomEvent('show-toast', { detail: { type: 'info', message } }));
  },
  warning: (message) => {
    window.dispatchEvent(new CustomEvent('show-toast', { detail: { type: 'warning', message } }));
  },
};
